module.exports = __webpack_public_path__ + "141660c7b9e42fbbccade1accc0a7155.fbx";